<template>
    <div class="caution" :class="[colored ? 'red' : '']">
        {{string}}
    </div>
</template>

<script>
export default {
name: "caution",
props: {
    string: {
      type: String,
      required: true,
    },
    colored:{
      type: Boolean,
      required: false,
      default: false      
    }
  },
  setup() {
  }
};
</script>

<style scoped lang="scss">
.caution {
  font-size: 13px;
  margin: 10px 15px;
  line-height: 15px;
  text-align: right;
}
.red{
  color: red;
}
</style>